import { render, staticRenderFns } from "./AgeRangePie.vue?vue&type=template&id=f2944922&"
import script from "./AgeRangePie.vue?vue&type=script&lang=js&"
export * from "./AgeRangePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports